import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm, reset } from 'redux-form'
import {
    Card, CardHeader, CardBody, Row, Col, Button, Input, Label, Modal, ModalHeader, ModalFooter, ModalBody, Form, FormGroup
} from 'reactstrap'
import { DataTable, ExportCSV, MainLoader } from '../../../../components'
import { getProduct, getProductOrders, createProductOrder, deleteProductOrder } from '../../../../store/product/actions'
import { getStores } from '../../../../store/store/actions'
import { layout } from '../../../../common/constants'
import { normalizeHelper, formatHelper } from '../../../../common/helpers'
import * as columns from './_columns'
import { validate } from './_validate'
import MediaQuery from 'react-responsive'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import { toast } from 'react-toastify'
import { getOrders as allOrdersExport } from '../../../../service/product'
import Swal from 'sweetalert2'
class ProductOrderList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            modalOpen: false,
            allOrdersExport: []
        }
        this.handleObtainOrdersExport = this.handleObtainOrdersExport.bind(this)
        this.handleExportCSV = this.handleExportCSV.bind(this)
        this.optionsFormatterColumn = this.optionsFormatterColumn.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
        this.handlePageChange = this.handlePageChange.bind(this)
        this.toggleModal = this.toggleModal.bind(this);
        this.renderStoresField = this.renderStoresField.bind(this);
    }

    componentDidMount() {
        const { id } = this.props.match.params
        this.props.getProduct(id)
        this.performGetOrders(true)
        this.props.getStores({ reset: true })
    }

    componentDidUpdate(prevProps) {
        this.checkOrderCreation(prevProps)
        this.checkOrderDelete(prevProps)
    }

    async checkOrderCreation(prevProps) {
        if (prevProps.newOrder == null && this.props.newOrder != null) {
            toast.success('Pedido creado satisfactoriamente')
            await this.setState({ page: 1, modalOpen: false })
            this.performGetOrders(true)
            this.props.resetForm('ProductOrderAddForm')
        } else if (prevProps.newOrderError == null && this.props.newOrderError != null) {
            toast.error(this.props.newOrderError)
        }
    }
    async checkOrderDelete(prevProps) {
        if (prevProps.deletedOrder == null && this.props.deletedOrder != null) {
            toast.success('Pedido eliminado satisfactoriamente')
            await this.setState({ page: 1 })
            this.performGetOrders()
        } else if (prevProps.deleteError == null && this.props.deleteError != null) {
            toast.error(this.props.deleteError)
        }
    }
    async handlePageChange(page) {
        await this.setState({ page: page })
        this.performGetOrders()
    }

    performGetOrders(reset = false) {
        const { page } = this.state
        const { id } = this.props.match.params
        this.props.getProductOrders({ id, reset, page })
    }

    toggleModal() {
        this.setState({
            modalOpen: !this.state.modalOpen
        });
    }

    onSubmit(values) {
        values.reception_date = values.reception_date._d
        this.props.createProductOrder(this.props.match.params.id, values)
    }
    renderDataTable(columns) {
        return (
            <DataTable
                data={this.props.orders}
                keyField='id'
                columns={columns}
                page={this.state.page}
                totalSize={this.props.total}
                sizePerPage={this.props.pageSize}
                loading={this.props.ordersLoading}
                onPageChange={this.handlePageChange}
            />
        )
    }

    renderInputField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'

        return (
            <FormGroup row>
                <Col md='3'>
                    <Label className={labelClass} >{field.label}</Label>
                </Col>
                <Col md="9">
                    <Input {...field.input} invalid={hasError} type={field.type} />
                </Col>
            </FormGroup>
        )
    }

    renderStoreItems() {
        return this.props.stores.map(store => {
            return (
                <option key={store.id} value={store.id}>{store.name}</option>
            )
        })
    }

    renderStoresField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false

        return (
            <FormGroup row>
                <Col md='3'>
                    <Label htmlFor="select">Tienda:</Label>
                </Col>
                <Col md="9">
                    <Input {...field.input} type="select" invalid={hasError} >
                        <option key={0} value={0}>Seleccione...</option>
                        {this.renderStoreItems()}
                    </Input>
                </Col>
            </FormGroup>
        )
    }

    renderReceptionDatePicker({ input, meta: { touched, error } }) {
        const className = touched && error ? 'form-control is-invalid' : 'form-control'

        return (
            <FormGroup row>
                <Col md='3'>
                    <Label>Fecha de Recepción:</Label>
                </Col>
                <Col md='9' >
                    <DatePicker
                        selected={input.value ? moment(input.value, 'DD/MM/YYYY') : null}
                        onChange={input.onChange}
                        className={className}
                        showYearDropdown
                        showMonthDropdown
                    />
                </Col>
            </FormGroup>
        )
    }

    async handleObtainOrdersExport() {
        await allOrdersExport(this.props.product.id, 0).then(response => {
            this.setState({
                allOrdersExport: response.data.data
            })
        })
        this.handleExportCSV()
    }

    handleExportCSV() {
        var csvRow = []
        var A = [['', 'Tienda', 'Cantidad', 'Costo Total', 'Fecha de Recepción', 'Estado']]
        var re = this.state.allOrdersExport
        for (var item = 0; item < re.length; item++) {
            A.push([item + 1, re[item].Store.name, re[item].quantity, re[item].total_price, re[item].reception_date, re[item].completed])
        }
        csvRow.push(A[0].join(","))
        for (var item = 1; item < A.length; item++) {
            A[item][1] = String(A[item][1]).replace(/\s/g, " ")
            A[item][3] = formatHelper.toTwoDecimal(A[item][3])
            A[item][4] = formatHelper.toDateDDMMYYY(A[item][4])
            A[item][5] = A[item][5] == true ? 'Recibido' : 'Pendiente'
            csvRow.push(A[item].join(","))
        }
        var csvString = csvRow.join("\r\n")

        var a = document.createElement("a")
        a.href = 'data:attachment/csv;charset=utf-16le,%EF%BB%BF' + encodeURI(csvString)
        a.target = "_Blank"
        a.download = formatHelper.toDateYYMMDD(new Date().toUTCString()) + "_reporte-general-ordenes_" + String(this.props.product.name).toLowerCase().replace(/\s/g, "-") + ".csv"
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }
    performDeleteProductOrder(id) {
        Swal({
            title: 'Eliminar pedido',
            text: '¿Estás seguro que deseas eliminar el pedido?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                this.props.deleteProductOrder(id)
            } else if (result.dismiss === Swal.DismissReason.cancel) {
            }
        })
    }
    optionsFormatterColumn(cell, row) {

        return (<Button type="button" disabled={this.props.deleteLoading} color="primary" size='sm' onClick={() => this.performDeleteProductOrder(row.id)} ><i className="fa fa-trash"></i></Button>)

    }

    render() {
        const columnOption = {
            dataField: '',
            text: '',
            formatter: this.optionsFormatterColumn,
            style: { width: '50px' },
            headerStyle: { width: '50px' }
        }
        const { product, handleSubmit, newOrderLoading } = this.props
        if (this.props.ordersLoading) {
            return <MainLoader />
        }
        return (
            <div className='animated'>
                <Card>
                    <CardHeader>
                        <i className="fa fa-list"></i>Pedidos de Producto
                    </CardHeader>
                    <CardBody>
                        <MediaQuery minDeviceWidth={600}>
                            {(matches) => {
                                if (matches) {
                                    return (
                                        <Row className='mb-2'>
                                            <Col sm="8">
                                                <b>Producto</b>: {product ? product.name : ''}
                                            </Col>
                                            <Col sm="4">
                                                <ExportCSV
                                                    exportCSV={this.handleObtainOrdersExport} />
                                            </Col>
                                        </Row>
                                    );
                                } else {
                                    return (
                                        <Row className='mb-2'>
                                            <Col md="10">
                                                <b>Producto</b>: {product ? product.name : ''}
                                            </Col>
                                            <Col md="2">
                                                <ExportCSV
                                                    exportCSV={this.handleObtainOrdersExport} />
                                            </Col>
                                        </Row>
                                    );
                                }
                            }}
                        </MediaQuery>
                        <hr className='my-4' />
                        <Row className='mb-2'>
                            <Col>
                                <div className='float-right'>
                                    <Button color="primary" onClick={this.toggleModal} ><i className="fa fa-plus mr-1"></i> Nuevo</Button>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <MediaQuery maxWidth={layout.XS_MAX_WIDTH} >
                                    {this.renderDataTable(columns.columnsXS(columnOption))}
                                </MediaQuery>
                                <MediaQuery minWidth={layout.SM_MIN_WIDTH} >
                                    {this.renderDataTable(columns.columnsSM(columnOption))}
                                </MediaQuery>
                            </Col>
                        </Row>
                        <Row>
                            <Col className='mt-3'>
                                <Button color='secondary' onClick={() => this.props.history.goBack()} ><i className="fa fa-chevron-left mr-1" /> Volver</Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <Modal isOpen={this.state.modalOpen} >
                    <Form onSubmit={handleSubmit(handleSubmit(this.onSubmit))}>
                        <ModalHeader>Nuevo Pedido</ModalHeader>
                        <ModalBody>
                            <Field name='quantity' label='Cantidad:' type='text' component={this.renderInputField} normalize={normalizeHelper.integerOnlyField(1)} />
                            <Field name='store_id' component={this.renderStoresField} />
                            <Field name='reception_date' component={this.renderReceptionDatePicker} /*normalize={normalizeHelper.dateOnlyField()} */ />
                        </ModalBody>
                        <ModalFooter>
                            <Row>
                                <Col className='mt-3'>
                                    <Button type='submit' disabled={newOrderLoading} color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                                    <Button color='secondary' onClick={this.toggleModal} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
                                </Col>
                            </Row>
                        </ModalFooter>
                    </Form>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {

    const { activeProduct, productOrdersList, newProductOrder } = state.product
    const { stores } = state.store.storeList

    return {
        product: activeProduct.product,
        productError: activeProduct.error,
        productLoading: activeProduct.loading,

        orders: productOrdersList.orders,
        ordersError: productOrdersList.error,
        ordersLoading: productOrdersList.loading,
        pageSize: productOrdersList.pageSize,
        total: productOrdersList.total,

        stores,

        newOrder: newProductOrder.order,
        newOrderError: newProductOrder.error,
        newOrderLoading: newProductOrder.loading,

        deletedOrder: state.product.deleteProductOrder.order,
        deleteError: state.product.deleteProductOrder.error,
        deleteLoading: state.product.deleteProductOrder.loading,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getProduct,
        getProductOrders,
        getStores,
        deleteProductOrder,
        createProductOrder,
        resetForm: reset,
    }, dispatch)
}

export default reduxForm({
    form: 'ProductOrderAddForm',
    touchOnBlur: false,
    // enableReinitialize: true,
    validate
})(
    connect(mapStateToProps, mapDispatchToProps)(ProductOrderList)
)


// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductOrderList/ProductOrderList.js